import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notification-grid',
  templateUrl: './notification-grid.component.html',
  styleUrls: ['./notification-grid.component.css']
})
export class NotificationGridComponent implements OnInit {

  title="Notification";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/notification/notification-grid/notification-grid.component.ts